<template>
  <HeadlessComboboxOptions
    v-if="suggestions?.length"
    class="relative mb-8 flex origin-top-left flex-col gap-1 overflow-y-auto bg-bgr py-4 focus:outline-none"
    :static="true"
  >
    <li v-if="!query" class="flex flex-col px-8">
      <h1 class="font-medium text-xl">
        {{ $t(`${trPrefix}popularDestinations`) }}
      </h1>
    </li>

    <HeadlessComboboxOption
      v-for="(option, index) in suggestions"
      :key="`${index}-${option.code}`"
      v-slot="{ selected, active }"
      :value="option"
      as="template"
    >
      <li
        class="cursor-pointe flex min-h-14 flex-row items-center gap-4 px-8"
        :class="{
          'bg-bgr-100': active || selected,
        }"
      >
        <WebccIcon
          :name="`content/${isSuggestionTypeAccom(option.type) ? 'house' : 'pin'}`"
          class="h-6 w-6 shrink-0"
          filled
        />

        <div class="flex flex-col gap-0">
          <span class="font-medium" :title="option.code">
            {{ option.label }}
          </span>
          <span class="font-medium text-txt-weak">
            {{ option.subtitle }}
          </span>
        </div>
      </li>
    </HeadlessComboboxOption>
  </HeadlessComboboxOptions>
</template>

<script setup lang="ts">
import type { SuggestionOption } from '~/composables/useDestinationSearch'
import { isSuggestionTypeAccom } from '~/utils/suggestions'

const trPrefix = 'www.components.site.Header.'

defineProps<{
  suggestions: SuggestionOption[]
  isOpen: boolean
  query: string
}>()
</script>
